<script>
  import API from '../Stores/API';
  import View from '../Stores/View';

	export let path = [];

  async function setLogout() {
    API.setUserLogOut();
    View.setView('authentication', {notice: 'Je bent succesvol uitgelogd.'});
  }
</script>

<style>
  .trail {
    border-bottom: 1px solid hsla(0, 100%, 100%, .1);
  }

  .trail a {
    color: inherit;
    cursor: pointer;
  }

  .trail h6 i {
    margin-left: .5em;
  }
</style>

<section class="pt-4">
	<div class="container-lg">
	  <div class="row align-items-center position-relative">
      <div class="col-12">
        <div class="trail">
          <div class="row align-items-center position-relative">
      	    <div class="col-12 col-lg-8 text-center text-lg-start">
      	      <h6 class="text-uppercase text-primary-light mb-0 pb-2">
      	      	{#each path as trail, index}
        	        {#if index}
                    <i class="fe fe-chevron-right text-gray-500"></i>
                  {/if}
                  {#if typeof trail[1] != 'undefined'}
                    <a on:click="{event => trail[1]()}">{trail[0]}</a>
                  {:else}
                    <span class="text-white">{trail[0]}</span>
                  {/if}
                {/each}
      	      </h6>
      	    </div>
      	    <div class="col-12 col-lg-4 text-center text-lg-end">
              <h6 class="text-uppercase mb-0 pb-2">
                <span class="text-white">{$API.data.user.name}</span>
                <i class="fe fe-user text-gray-500"></i>
                <a class="text-uppercase text-primary-light" on:click="{event => { setLogout() }}">Uitloggen</a>
              </h6>
      	    </div>
          </div>
        </div>
  	  </div>
    </div>
	</div>
</section>